/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'media': {
    width: 17,
    height: 18,
    viewBox: '0 0 17 18',
    data: '<path pid="0" d="M14.446 8.642V6.926h-3.392V3.534H9.338v3.392H5.946v1.716h3.392v3.392h1.716V8.642h3.392zM15.324.98c.452 0 .845.166 1.177.499.333.332.499.725.499 1.177v10.216c0 .452-.166.851-.499 1.197-.332.346-.725.519-1.177.519H5.108c-.452 0-.851-.173-1.197-.519-.346-.346-.519-.745-.519-1.197V2.656c0-.452.173-.845.519-1.177.346-.333.745-.499 1.197-.499h10.216zM1.676 4.372v11.932h11.932v1.676H1.676A1.61 1.61 0 0 1 .5 17.481 1.61 1.61 0 0 1 0 16.304V4.372h1.676z" _fill="#90A4AE" fill-rule="evenodd"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/media.js